export const convertFormTimeValueToKnmDataTime = (time: string | Date | null | undefined): string | null => {
  if (!time) {
    return null;
  }

  // Проверяем что это строка, т.к. time может быть еще Date (например Date по умолчанию устанавливает TimePickerField)
  if (typeof time === 'string') {
    // 1) Европейский формат: DD.MM.YYYY HH:mm(:ss)
    // т.к. new Date() не умеет из европейского формата
    const match = time.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/);

    if (match) {
      const [, , , , /* day */ /* month */ /* year */ hh, mm, ss] = match;
      const hours = hh.padStart(2, '0');
      const minutes = mm.padStart(2, '0');
      const seconds = (ss ?? '00').padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    }
  }

  // 2) Всё остальное — доверяем нативному парсеру (ISO, американский и т.п.)
  const date = new Date(time);

  if (!Number.isNaN(date.getTime())) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  return null;
};
